<template>
  <preview-sp>
    <template v-if="isFinishCreated">
      <!-- 求人プレビュー -->
      <job-preview-detail-sp
        :offer="offer"
        class="sp-print-area"
      />

      <p class="margin-1 pega-hide-msg">
        これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。あらかじめご了承ください。
      </p>
      <!-- 職種設定 -->
      <job-category-setting-sp :job-category-settings="offer.jobCategorySettings" />
      <!-- マッチング設定 -->
      <job-matching-setting-sp
        v-if="matching"
        :matching="matching"
      />
    </template>
  </preview-sp>
</template>

<script>
import PreviewSp from '@/components/templates/PreviewSp'
import JobPreviewDetailSp from '@/components/organisms/JobPreviewDetailSp'
import JobCategorySettingSp from '@/components/molecules/JobCategorySettingSp'
import JobMatchingSettingSp from '@/components/molecules/JobMatchingSettingSp'
import bossSCommon from '@/lib/bossSCommon'
import { mapActions } from 'vuex'

export default {
  components: {
    PreviewSp,
    JobPreviewDetailSp,
    JobCategorySettingSp,
    JobMatchingSettingSp
  },
  mixins: [bossSCommon],
  data () {
    return {
      isFinishCreated: false, // createdの処理完了を待ってから描画するためのフラグ
      offer: {}, // 求人情報
      matching: {} // マッチング設定
    }
  },
  created () {
    const apis = [
      // 求人情報取得API
      this.$http.secured.get(this.apiPathForFetchJobs),
      // マッチング設定取得API
      this.$http.secured.get(`${this.apiPath}/matching`),
      // マスタ一括取得
      this.storeMaster('prIcons'),
      this.storeMaster('skills')
    ]

    Promise.all(apis).then(([
      offerResponse, // 求人情報取得API
      matchingResponse // マッチング設定取得API
    ]) => {
      this.$set(this, 'offer', offerResponse.data)
      this.$set(this, 'matching', matchingResponse.data)

      this.$set(this, 'isFinishCreated', true)
    })
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
